import { pageInfo } from "../../utils/helper";
import {INVOICE_LOAD_FAILED, INVOICE_LOAD_START, INVOICE_LOAD_SUCCESS} from "../actions/invoice";

const initialState = {
  invoices: [],
  loading: false,
  error: false,
  pageInfo: { totalCount: 0 },
}

export const invoiceReducer = (state = initialState, action) => {
  switch (action.type) {
    case INVOICE_LOAD_START:
      return {
        ...state,
        loading: true,
        error: false,
      }
    case INVOICE_LOAD_SUCCESS:
      return {
        ...state,
        loading: false,
        invoices: normalizeInvoiceData(action.payload),
        pageInfo: pageInfo(action.payload.fosaClaimInvoice)
      }
    case INVOICE_LOAD_FAILED:
      return {
        ...state,
        loading: false,
        error: action.payload,
      }
    default:
      return state
  }
}

function normalizeInvoiceData(data) {
  return data.fosaClaimInvoice.edges.map(e => e['node'])
}